import { render, staticRenderFns } from "./MasterDataDetailRow.vue?vue&type=template&id=1b7a4139"
import script from "./MasterDataDetailRow.vue?vue&type=script&lang=js"
export * from "./MasterDataDetailRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports